import CaseList from './CaseList';

export default CaseList;
